module.exports = __webpack_public_path__ + "67773a0cbb49767f600be05d5104869a.png";